import { Check } from "lucide-react";
import type React from "react";

interface StepIndicatorProps {
	currentStep: number;
	totalSteps: number;
	stepLabels: string[];
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
	currentStep,
	totalSteps,
	stepLabels,
}) => {
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				gap: "0",
				width: "100%",
				padding: "0 1rem",
			}}
		>
			{Array.from({ length: totalSteps }, (_, i) => {
				const stepNum = i + 1;
				const isCompleted = stepNum < currentStep;
				const isCurrent = stepNum === currentStep;

				return (
					<div
						key={stepNum}
						style={{
							display: "flex",
							alignItems: "center",
							flex: i < totalSteps - 1 ? 1 : "none",
						}}
					>
						{/* Step circle */}
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								minWidth: "2.5rem",
							}}
						>
							<div
								style={{
									width: "2.25rem",
									height: "2.25rem",
									borderRadius: "50%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									fontSize: "0.75rem",
									fontWeight: 600,
									transition: "all 0.2s ease",
									background: isCompleted
										? "var(--color-success)"
										: isCurrent
											? "var(--color-primary)"
											: "var(--color-bg-secondary)",
									color:
										isCompleted || isCurrent
											? "#fff"
											: "var(--color-text-secondary)",
									border: isCurrent
										? "2px solid var(--color-primary)"
										: "2px solid transparent",
								}}
							>
								{isCompleted ? <Check size={14} /> : stepNum}
							</div>
							<span
								style={{
									fontSize: "0.65rem",
									marginTop: "0.35rem",
									color: isCurrent
										? "var(--color-text-primary)"
										: "var(--color-text-secondary)",
									fontWeight: isCurrent ? 600 : 400,
									textAlign: "center",
									whiteSpace: "nowrap",
								}}
							>
								{stepLabels[i]}
							</span>
						</div>

						{/* Connector line */}
						{i < totalSteps - 1 && (
							<div
								style={{
									flex: 1,
									height: "2px",
									marginBottom: "1.25rem",
									marginLeft: "0.25rem",
									marginRight: "0.25rem",
									background: isCompleted
										? "var(--color-success)"
										: "var(--color-border)",
									transition: "background 0.2s ease",
								}}
							/>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default StepIndicator;
